<h2 mat-dialog-title class="d-flex justify-content-center text-primary">
  Sending questionnaire to&nbsp;<span class="bold">{{data.clientName}}</span>
</h2>
<mat-dialog-content class="mat-typography vw-50">
  <mat-radio-group [(ngModel)]="respondVia" aria-label="Select an option" class="my-4 justify-content-around justify-content-center" (change)="setPortalErrorMessage()">
    <mat-radio-button class="d-flex send-qs" [value]="'portal'">Answer via client portal</mat-radio-button>
    <mat-radio-button class="d-flex send-qs" [value]="'external'">Answer through client email link</mat-radio-button>
    <mat-radio-button class="d-flex send-qs" [value]="'custom'">
      <span>Answer through different email link</span>
      <span class="send-qs-custom-email" *ngIf="respondVia == 'custom'">
        <input matInput [(ngModel)]="customEmail" placeholder="Enter email here...">
      </span>
    </mat-radio-button>
  </mat-radio-group>
  <!--<div class="my-4 external-questionnaire" *ngIf="respondVia == 'external'">
    <div class="medium-12 columns mt-2" style="border-left: 1px solid #17457b">
      <div class="d-flex">
        <mat-form-field class="w-90" [floatLabel]="'never'">
          <mat-label>Email*</mat-label>
          <input matInput [(ngModel)]="email">
        </mat-form-field>
      </div>
      <div class="d-flex">
        <mat-form-field class="w-90" [floatLabel]="'never'">
          <mat-label>Subject*</mat-label>
          <input matInput [(ngModel)]="mailSubject">
        </mat-form-field>
      </div>
      <div>
        <div class="question-menu qs-froala-toolbar" [froalaEditor]="editorObj"  [(froalaModel)]="mailBody"></div>
      </div>
    </div>
  </div>-->
</mat-dialog-content>
<h2 *ngIf="showErrorForPortal" mat-dialog-title class="d-flex justify-content-center text-primary" style="color: #F06459 !important;">
  Portal not enabled for&nbsp;<span class="bold">{{data.clientName}}</span>.
</h2>
<h2 *ngIf="showErrorForEmail" mat-dialog-title class="d-flex justify-content-center text-primary" style="color: #F06459 !important;">
  Email is Required.
</h2>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>CANCEL</button>
  <button mat-button cdkFocusInitial class="bg-light-blue text-white" (click)="sendQuestionnaire()">
    <mat-icon *ngIf="loader">
      <mat-spinner [diameter]="20" color="primary"></mat-spinner>
    </mat-icon>
    SEND
  </button>
</mat-dialog-actions>
